import React from 'react';
import { ShieldCheck, Globe, Award, CheckCircle2, Zap } from 'lucide-react';

const CertificationBar = () => {
  const certs = [
    { label: "ISO 9001:2015", icon: <ShieldCheck size={14} /> },
    { label: "ISO 9712 Compliance", icon: <CheckCircle2 size={14} /> },
    { label: "ASNT LEVEL III Experts", icon: <Award size={14} /> },
    { label: "PAUT/TOFD Certified", icon: <Zap size={14} /> },
    { label: "Global Mobility Ready", icon: <Globe size={14} /> }
  ];

  return (
    <div className="bg-slate-950 py-12 border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-wrap justify-center items-center gap-x-12 gap-y-8">
          {certs.map((c, i) => (
            <div 
              key={i} 
              className="group flex items-center space-x-3 opacity-40 hover:opacity-100 grayscale hover:grayscale-0 transition-all duration-500 cursor-default"
            >
              <div className="text-orange-600 group-hover:scale-110 transition-transform duration-300">
                {c.icon}
              </div>
              <span className="text-white font-black text-[10px] tracking-[0.3em] uppercase whitespace-nowrap">
                {c.label}
              </span>
              
              {/* Vertical Divider (Hidden on the last item and on mobile) */}
              {i !== certs.length - 1 && (
                <div className="hidden lg:block h-4 w-px bg-white/10 ml-12"></div>
              )}
            </div>
          ))}
        </div>
        
        {/* Subtle Bottom Caption */}
        <div className="mt-8 text-center">
          <p className="text-[8px] font-bold text-slate-600 uppercase tracking-[0.5em]">
            Verified Industrial Standards • Focus NDT Group Quality Assurance
          </p>
        </div>
      </div>
    </div>
  );
};

export default CertificationBar;